export const WorkflowTypeTranslation: { [key: number]: string } = {
  1: $localize`Care`,
  2: $localize`Registration`,
  3: $localize`Checkout`,
};
